import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container } from '@pella/sash-framework';
import { Layout, SEO, Breadcrumbs } from '../../components';

import ImageBanner from '../../components/common/image-banner';
import DynamicComponent from '../../components/common/dynamic-component';
import CardSection from '../../components/common/card-section';
import HeroSimple from '../../components/common/hero-simple';
import Feature from '../../components/common/feature';

import styles from './index.module.scss';

const FNOType = (props) => {
	const pageData = props.data.contentstackFnoType;

	return (
		<Layout
			id='template-FNOType'
			pageTitle={pageData.seo?.title}
		>
			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.hero && <HeroSimple data={pageData.hero} />}

			{pageData.top_content && (
				<div className={`${styles.sectionWrapper} ${styles.options}`}>
					<Container width={1200}>
						{pageData.top_content.heading && <h2 className={`${styles.sectionTitle} s2-h2__alt`}>{pageData.top_content.heading}</h2>}

						{pageData.top_content.description && (
							<div
								dangerouslySetInnerHTML={{
									__html: pageData.top_content.description,
								}}
							/>
						)}
					</Container>
				</div>
			)}

			{pageData.page_components?.[0] &&
				pageData.page_components.map((block, index) => {
					if (block.cards != null) {
						return (
							<CardSection
								data={block.cards}
								key={index}
							/>
						);
					}

					if (block.all_dynamic != null) {
						return (
							<DynamicComponent
								data={block.all_dynamic}
								key={index}
							/>
						);
					}

					if (block.image_aside != null && block.image_aside.callout) {
						return (
							<ImageBanner
								data={block.image_aside}
								key={index}
							/>
						);
					}

					if (block.image_aside != null && !block.image_aside.callout) {
						return (
							<Feature
								data={block.image_aside}
								key={index}
							/>
						);
					}
				})}
		</Layout>
	);
};

FNOType.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default FNOType;

// eslint-disable-next-line react/prop-types -- fix this
export const Head = ({ data }) => <SEO {...data.contentstackFnoType.seo} />;

export const query = graphql`
	query ($uid: String!) {
		contentstackFnoType(id: { eq: $uid }) {
			url

			breadcrumbs {
				active_page
				back_pages {
					...CTA
				}
			}

			hero {
				image {
					...Image
					image {
						gatsbyImageData(width: 1500, quality: 90)
					}
				}
				body
			}

			top_content {
				heading
				description
			}

			page_components {
				cards {
					...CardSection
				}
				image_aside {
					...ImageAside
				}
				all_dynamic {
					heading
					dynamic {
						...Dynamic
					}
				}
			}

			seo {
				title
				description
				noIndex: no_index_page
			}
		}
	}
`;
